import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN' //引入中文文件

Vue.use(VeeValidate)

Validator.localize('zh', zh)

const dictionary = {
  zh: {
    messages: {
      email: () => '请输入正确的邮箱格式',
      required: field => '请输入' + field
    },
    attributes: {
      email: '邮箱',
      password: '密码',
      name: '姓名',
      phone: '手机号码',
      card: '身份证号码',
      postCard: '护照号码',
      gatCard: '港澳台通行证',
      foreignCard: '外国人永居证'
    }
  }
}

Validator.localize(dictionary)

Validator.extend('phone', {
  getMessage: field => field + '格式错误',
  validate: value => {
    return value.length === 11 && /^1(1|2|3|4|5|6|7|8|9)\d{9}$/.test(value)
  }
})

Validator.extend('password', {
  getMessage: field => field + '为6至10位登录密码，至少包含一位数字和字母',
  validate: value => {
    return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(value)
  }
})

// 身份证
Validator.extend('card', {
  getMessage: field => field + '格式错误',
  validate: value => {
    /*let reg1 = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9XxAa]$/
    let reg2 = /^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9XxAa]$/
    let reg3 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/
    let reg4 = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/

    return (
      reg1.test(value) ||
      reg2.test(value) ||
      reg3.test(value) ||
      reg4.test(value)
    )*/

    // 15位和18位身份证号码的正则表达式
    var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/

    // 如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(value)) {
      if (value.length == 18) {
        var idCardWi = new Array(
          7,
          9,
          10,
          5,
          8,
          4,
          2,
          1,
          6,
          3,
          7,
          9,
          10,
          5,
          8,
          4,
          2
        ) // 将前17位加权因子保存在数组里
        var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2) // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
        var idCardWiSum = 0 // 用来保存前17位各自乖以加权因子后的总和
        for (var i = 0; i < 17; i++) {
          idCardWiSum += value.substring(i, i + 1) * idCardWi[i]
        }

        var idCardMod = idCardWiSum % 11 // 计算出校验码所在数组的位置
        var idCardLast = value.substring(17) // 得到最后一位身份证号码

        // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
        if (idCardMod == 2) {
          if (idCardLast == 'X' || idCardLast == 'x') {
            //alert("恭喜通过验证啦！");
            return true
          } else {
            //alert("身份证号码错误！");
            return false
          }
        } else {
          // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
          if (idCardLast == idCardY[idCardMod]) {
            //alert("恭喜通过验证啦！");
            return true
          } else {
            //alert("身份证号码错误！");
            return false
          }
        }
      } else {
        return true
      }
    } else {
      //alert("身份证格式不正确!");
      return false
    }

    // return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)
  }
})

// https://juejin.im/post/5d1c6ad1e51d45106172112f
// 护照
// 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
// 样本： 141234567, G12345678, P1234567
Validator.extend('postCard', {
  getMessage: field => field + '格式错误',
  validate: value => {
    let re1 = /^[a-zA-Z]{5,17}$/
    let re2 = /^[a-zA-Z0-9]{5,17}$/
    return re1.test(value) || re2.test(value)
  }
})

// 港澳台通行证
// Validator.extend('gatCard', {
//   getMessage: field => field + '格式错误',
//   validate: value => {
//     let re1 = /^([A-Z]\\d{6,10}(\\w1)?)$/ // 港澳
//     let re2 = /^[a-zA-Z][0-9]{9}$/ // 台湾
//     return re1.test(value) || re2.test(value)
//   }
// })
